import type { StringValue } from '../../../value/types';
import type { SUPPORTED_KEY_TYPES } from '../types';

const getKeyValue: StringValue<{
	fieldId: string;
	type: SUPPORTED_KEY_TYPES;
	value: string | null;
}> = (field) => String(field.value || '');

export const keyStringValueHandler = {
	key: getKeyValue,
};
